/**
 * Combine the Per instance frame data, the shared frame data
 * and the root data objects.
 * The data is combined by taking nested sequence objects within
 * the functional group sequences.  Data that is directly contained
 * within the functional group sequences, such as private creators
 * will be ignored.
 * This can be safely called with an undefined frame in order to handle
 * single frame data. (eg frame is undefined is the same as frame===1).
 */
const combineFrameInstance = (frame, instance) => {
  const {
    PerFrameFunctionalGroupsSequence,
    SharedFunctionalGroupsSequence,
    NumberOfFrames,
  } = instance;

  if (PerFrameFunctionalGroupsSequence === undefined
    || PerFrameFunctionalGroupsSequence === null
    || SharedFunctionalGroupsSequence === undefined
    || SharedFunctionalGroupsSequence === null)
    return instance;

  if (PerFrameFunctionalGroupsSequence || NumberOfFrames > 1) {
    try {
      let frameNumber = Number.parseInt(frame || 1);
      frameNumber = frameNumber - 1;
      frameNumber = frameNumber === undefined ? 0 : frameNumber;
      const shared = (SharedFunctionalGroupsSequence
        //? SharedFunctionalGroupsSequence[0] && Object.values(SharedFunctionalGroupsSequence[0])
        ? SharedFunctionalGroupsSequence[0]
        : []
      )
        .map(it => it[0])
        .filter(it => it !== undefined && typeof it === 'object');
      const perFrame = (PerFrameFunctionalGroupsSequence
        ? PerFrameFunctionalGroupsSequence[frameNumber] && Object.values(PerFrameFunctionalGroupsSequence[frameNumber])
        : []
      )
        .map(it => it[0])
        .filter(it => it !== undefined && typeof it === 'object');

      return Object.assign(
        { frameNumber: frameNumber },
        instance,
        ...Object.values(shared),
        ...Object.values(perFrame)
      );
    } catch (error) {
      return instance;
    }
  } else {
    return instance;
  }
};

export default combineFrameInstance;
